import {
  ADD_TEMPLATE_FAIL,
  ADD_TEMPLATE_SUCCESS,
  DELETE_TEMPLATE_FAIL,
  DELETE_TEMPLATE_SUCCESS,
  GET_TEMPLATES_LIST_FAIL,
  GET_TEMPLATES_LIST_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  list: [],
  res: [],
  error: [],
};

const Template = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TEMPLATES_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case GET_TEMPLATES_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_TEMPLATE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case DELETE_TEMPLATE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_TEMPLATE_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ADD_TEMPLATE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Template;
